module.exports = __webpack_public_path__ + "static/img/temp-overview@t.b7991ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-overview@t.png
// module id = 6ARd
// module chunks = 0